module.exports = __webpack_public_path__ + "img/blog-20.e744c959.jpg";